import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { StyledVerticalNavigationItem } from "./styled";
import { IVerticalNavigationItemProps } from "./types";

const VerticalNavigationItem = ({ label, onClick }: IVerticalNavigationItemProps) => {
    return (
        <StyledVerticalNavigationItem onClick={onClick}>
            <div className="item-wrapper">
                <Text variant="V2.body1.neutral.bold" color={"text_High_Emphasis"} maxLines={1}>
                    {label}
                </Text>
            </div>
        </StyledVerticalNavigationItem>
    );
};

export default memo(VerticalNavigationItem);
